import { pick } from 'lodash';
import keymirror from 'keymirror';

export const socialMediaTypeList = keymirror({
  facebook: null,
  youtube: null,
  linkedin: null,
  google: null,
  instagram: null,
  twitter: null,
  pinterest: null,
});

const socialMediaList = {
  [socialMediaTypeList.facebook]: {
    value: socialMediaTypeList.facebook,
    label: 'Facebook',
    className: 'icon-custom-facebook',
    color: '#3c5b9b',
    anchor: 'Like',
    url: 'https://facebook.com/',
  },
  [socialMediaTypeList.youtube]: {
    value: socialMediaTypeList.youtube,
    label: 'Youtube',
    className: 'icon-custom-youtube',
    color: '#e14e42',
    anchor: 'Subscribe',
    url: 'https://www.youtube.com/',
  },
  [socialMediaTypeList.linkedin]: {
    value: socialMediaTypeList.linkedin,
    label: 'Linkedin',
    className: 'icon-custom-linkedin',
    color: '#0173B2',
    anchor: 'Connect',
    url: 'https://www.linkedin.com/',
  },
  [socialMediaTypeList.google]: {
    value: socialMediaTypeList.google,
    label: 'Google Plus',
    className: 'icon-custom-google-plus',
    color: '#f63d27',
    anchor: 'Follow',
    url: 'https://plus.google.com/',
  },
  [socialMediaTypeList.instagram]: {
    value: socialMediaTypeList.instagram,
    label: 'Instagram',
    className: 'icon-custom-instagram',
    color: '#517fa4',
    anchor: 'Add',
    url: 'https://www.instagram.com/',
  },
  [socialMediaTypeList.twitter]: {
    value: socialMediaTypeList.twitter,
    label: 'Twitter',
    className: 'icon-custom-twitter',
    color: '#2daae1',
    anchor: 'Follow',
    url: 'https://twitter.com/',
  },
  [socialMediaTypeList.pinterest]: {
    value: socialMediaTypeList.pinterest,
    label: 'Pinterest',
    className: 'icon-custom-pinterest',
    color: '#D90C35',
    anchor: 'Pin it!',
    url: 'https://www.pinterest.com/',
  },
};

export const defaultPropsKeyList = ['value', 'anchor', 'url'];
const dropDownKeyList = ['value', 'label'];

export const socialMediaTypeArray = Object.keys(socialMediaTypeList);

export const getSocialDefaultProps = optionType =>
  pick(socialMediaList[optionType], defaultPropsKeyList);

export const getSocialDropdownProps = optionType =>
  pick(socialMediaList[optionType], dropDownKeyList);

export default socialMediaList;
